import { render, staticRenderFns } from "./relatedOrders.vue?vue&type=template&id=37d1baf7"
import script from "./relatedOrders.vue?vue&type=script&lang=js"
export * from "./relatedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports